import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const OrganizationsAccountSettingsComponent = ({ selectOrganizationsSettings, handleInnerFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                  <InputContainer
                    label="Auto Approval"
                    name="AutoApproval"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'AccountSettings.AutoApproval',
                        selectOrganizationsSettings?.AccountSettings
                    )
                    }}
                    type="checkbox"
                    value={selectOrganizationsSettings?.AccountSettings?.AutoApproval}
                />  
            </div>
            }
        expandedPanel="Account Settings"
        headerTitle="Account Settings"
        />
        </>
  )
}
export default OrganizationsAccountSettingsComponent;
